let eventObj = {}
const event = {
  register: function (name, fn) {
    if (eventObj[name]) {
      eventObj[name].push(fn)
    } else {
      eventObj[name] = [fn]
    }
  },
  fire: function (name, param) {
    setTimeout(() => {
      if (eventObj[name]) {
        eventObj[name].map(fn => fn(param))
      }
    }, 100);
  }
}
export default event
